import type { Plugin } from './plugin'

export class Selectors {
  public readonly isDownloading

  constructor(plugin: Plugin) {
    this.isDownloading = plugin.feature.state.project(
      state => state.isDownloading,
    )
  }
}
